content-line {
  --text-align: default;
  --inner-max-width: 100%;

  display: block;
  text-align: var(--text-align);
  word-break: break-word;
  white-space: normal;
  
  .content-line__inner {
    display: inline-block;
    width: auto;
    max-width: var(--max-width);
  }
}